import { projectIdState } from '../../project.state';
import type {
  File,
  FileLinkDownloadHandler,
  FileModeType,
} from '@/features/action-panel/files/file.interface';
import { fetchProjectFileLink } from '@/api/v4/project-files.api';
import { downloadLinkAutomatically } from '@/helpers/download-link-automatically';
import { useAtomValue } from 'jotai';

export const useProjectFilesActions = () => {
  const projectId = useAtomValue(projectIdState);

  const downloadProjectFile: FileLinkDownloadHandler = async (
    file: File,
    mode: FileModeType,
  ) => {
    if (!projectId) return;

    const link = await fetchProjectFileLink(
      {
        projectId,
        fileId: file.id,
      },
      {
        mode,
      },
    );

    await downloadLinkAutomatically(link, file.name);
  };

  return {
    downloadProjectFile,
  };
};
